import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class Log<SV, SE = any, SC = any> extends Pass<SV, SE, SC> {
    protected logKey: string
    protected toJson: boolean | undefined

    constructor(logKey: string, source?: AnySourceStream<SV, SE, SC>, toJson?: boolean) {
        super(source)
        this.logKey = logKey
        this.toJson = toJson
    }

    value(value: SV) {
        if (this.toJson) {
            console.log(this.logKey, JSON.stringify(value))
        } else {
            console.log(this.logKey, value)
        }
        this._value(value as any)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        log(logKey: string, toJson?: boolean): Stream<DV, DE, DC, DV, DE, DC>
    }
}

Stream.prototype.log = function <SV, SE, SC>(this: AnySourceStream<SV, SE, SC>, logKey: string, toJson?: boolean) {
    return new Log(logKey, this, toJson) // tslint:disable-line:no-invalid-this
}
